<script>
    import Respuestas from "./../models/respuestas.svelte";
    import TablaComentarios from "./../models/tablaComenarios.svelte";
    import TablaRespuestas from "./../models/tabListResp.svelte";
    import Tendencias from "../models/tendencias.svelte";
    import Tarjeta from "../models/tarjetas.svelte";
    import { panelController } from "../../../../stores/service";
    import { analyticsFilters } from "../../../../stores/analyticsFilters";

    import mainViewAnalytics from "../../../../Controller/analytics/viewMain.js";
    import { modelAnalytics } from "../../../../Models/analytics/analytics.js";

    export let data = {
        name: "nombre",
        datalist: { idfirebase: "" },
        listindex: 0,
    };

    let loading = false;
    let loadError = "";
    let seenSeq = $analyticsFilters.seq;

    let view_analytics, mode_Analytics;
    let tarjetaRatings, tarjetaPromedio, tarjetaTime;
    let intervalosTiempo, tendenciasMesas;

    let cuestionario;
    let comentarios;
    let tablaRespuestas = [];

    function main() {
        view_analytics = new mainViewAnalytics(
            $panelController.service,
            data.listindex,
        );
        view_analytics._main();

        view_analytics.verificarData();
        setdata();
    }

    async function maingetlist() {
        setdata();
    }

    async function loadRange(f) {
        loading = true;
        loadError = "";
        try {
            await view_analytics.obtenerDatos({
                rangoFechas: { f1: f.f1, f2: f.f2 },
                id: data.datalist.idfirebase,
            });
            await setdata();
        } catch (err) {
            console.error("No se pudieron cargar las estadísticas", err);
            loadError = "No se pudieron cargar los datos de este periodo.";
        } finally {
            loading = false;
        }
    }

    $: if ($analyticsFilters.seq !== seenSeq) {
        seenSeq = $analyticsFilters.seq;
        loadRange($analyticsFilters);
    }

    main();

    async function setdata() {
        /* Tarjetas */
        tarjetaRatings = view_analytics.tarjetaRatings;
        tarjetaPromedio = view_analytics.tarjetaPromedio;
        tarjetaTime = view_analytics.tarjetaTime;

        /* Panel */
        intervalosTiempo = view_analytics.intervalosTiempo;
        tendenciasMesas = view_analytics.promMesa;

        /* Respuestas */
        cuestionario = view_analytics.cuestionarios;

        /* comentarios */
        comentarios = view_analytics.comentarios;
   
        

        tablaRespuestas = view_analytics.tablaRespuestas;
    }

    $: hasCharts = intervalosTiempo && intervalosTiempo.data.labels.length > 0;
    $: hasSurvey = cuestionario.length > 0 || comentarios.length > 0;
</script>

<div class="dash" class:is-loading={loading}>
        {#if loading}
            <p class="dash-status" role="status">Cargando datos…</p>
        {/if}
        {#if loadError}
            <p class="dash-status dash-error" role="alert">{loadError}</p>
        {/if}

        <div class="kpis">
            <Tarjeta data={tarjetaRatings} />
            <Tarjeta data={tarjetaPromedio} />
            <Tarjeta data={tarjetaTime} />
        </div>

        {#if hasCharts}
            <h2 class="dash-title">Tiempos de mesa</h2>
            <div class="grid">
                <Tendencias data={intervalosTiempo} />
                <Tendencias data={tendenciasMesas} kind="bar" />
            </div>
        {/if}

        {#if hasSurvey}
            <h2 class="dash-title">Encuesta</h2>
            <div class="grid">
                {#each cuestionario as element}
                    <Respuestas
                        data_PolarArea={element.polar}
                        data_line={element.line}
                        name={element.pregunta}
                    />
                {/each}
            </div>
            <div class="stack">
                <TablaComentarios data={comentarios} />
            </div>
        {/if}

        {#if !hasCharts && !hasSurvey}
            <p class="dash-empty">
                Sin datos para este periodo. Cambia el rango en Filtros.
            </p>
        {/if}

        <div class="stack">
            <TablaRespuestas
                data={tablaRespuestas}
                {view_analytics}
                on:set_data={maingetlist}
            />
        </div>
</div>

<style>
    .dash {
        transition: opacity 0.2s ease;
    }

    .dash.is-loading {
        opacity: 0.6;
    }

    .dash-status,
    .dash-empty {
        margin: 0.75rem 0;
        font-size: 0.85rem;
        color: #83805f;
    }

    .dash-error {
        color: var(--coral-600);
    }

    .dash-title {
        margin: 1.25rem 0 0.5rem;
        font-size: 0.95rem;
        font-weight: 700;
        color: #2c3320;
    }

    .kpis {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.75rem;
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(min(100%, 420px), 1fr));
        gap: 0.75rem;
    }

    /* The child blocks were written for Bootstrap columns; inside these
       grids the grid does the sizing. */
    .kpis > :global([class*="col-"]),
    .grid > :global([class*="col-"]),
    .stack > :global([class*="col-"]) {
        flex: none;
        width: auto;
        max-width: none;
        padding: 0;
    }

    .stack {
        margin-top: 0.75rem;
    }

    .kpis :global(.small-box),
    .grid :global(.card),
    .stack :global(.card) {
        margin-bottom: 0;
    }

    .kpis :global(.small-box) {
        border-radius: 10px;
        overflow: hidden;
        position: relative;
    }

    .kpis :global(.small-box .inner) {
        padding: 0.6rem 0.9rem;
    }

    .kpis :global(.small-box h3) {
        font-size: 1.6rem;
        margin: 0;
    }

    .kpis :global(.small-box p) {
        margin: 0;
        font-size: 0.8rem;
    }

    .kpis :global(.small-box .icon) {
        font-size: 2.6rem;
        top: 0.3rem;
    }

    /* ---- Landing-page look: cream surfaces, olive ink, Fraunces numerals ---- */
    .dash :global(.card) {
        background: var(--cream);
        color: var(--ink);
        border: 1px solid rgba(44, 51, 32, 0.08);
        border-radius: 18px;
        box-shadow: var(--shadow-soft);
        overflow: hidden;
    }

    .dash :global(.card > .card-header) {
        background: transparent !important;
        color: var(--olive-900) !important;
        border-bottom: 0;
        padding: 0.85rem 1.1rem 0.15rem;
    }

    .dash :global(.card-title) {
        font-family: "Fraunces", ui-serif, Georgia, serif;
        font-weight: 600;
        font-size: 1rem;
        color: var(--olive-900);
        margin: 0;
    }

    .dash :global(.card-tools .btn-tool),
    .dash :global(.card-tools .btn-tool i) {
        color: var(--ink-soft) !important;
    }

    .dash :global([data-card-widget="remove"]) {
        display: none;
    }

    .dash-title {
        font-family: "Fraunces", ui-serif, Georgia, serif;
        font-weight: 600;
        font-size: 1.05rem;
    }

    .kpis :global(.small-box) {
        background: var(--cream) !important;
        color: var(--ink) !important;
        border: 1px solid rgba(44, 51, 32, 0.08);
        border-radius: 18px;
        box-shadow: var(--shadow-soft);
        padding-left: 0.4rem;
    }

    .kpis :global(.small-box::before) {
        content: "";
        position: absolute;
        top: 0.85rem;
        left: 0.9rem;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--olive-600);
    }

    .kpis > :global(:nth-child(2) .small-box::before) {
        background: var(--coral-600);
    }

    .kpis > :global(:nth-child(3) .small-box::before) {
        background: var(--yellow-500);
    }

    .kpis :global(.small-box .inner) {
        padding: 1.6rem 1rem 0.7rem 0.9rem;
    }

    .kpis :global(.small-box h3) {
        font-family: "Fraunces", ui-serif, Georgia, serif;
        font-weight: 600;
        font-size: 1.9rem;
        color: var(--olive-900);
    }

    .kpis > :global(:nth-child(2) .small-box h3) {
        font-family: "DM Sans", ui-sans-serif, system-ui, sans-serif;
        font-variant-numeric: tabular-nums;
        letter-spacing: 0.03em;
        color: var(--coral-600);
    }

    .kpis :global(.small-box p) {
        color: var(--ink-soft);
        font-weight: 600;
    }

    .kpis :global(.small-box .icon) {
        color: var(--olive-200);
        opacity: 0.8;
    }

    .stack :global(.card .table) {
        color: var(--ink);
    }

    .kpis :global(.small-box) {
        text-align: left;
    }

    @media (max-width: 575px) {
        .kpis {
            grid-template-columns: 0.8fr 1.35fr 0.95fr;
            gap: 0.4rem;
        }

        .kpis :global(.small-box .inner) {
            padding: 1.2rem 0.6rem 0.5rem 0.7rem;
        }

        .kpis :global(.small-box h3) {
            font-size: 1.15rem;
        }

        .kpis > :global(:nth-child(2) .small-box h3) {
            letter-spacing: 0;
            font-size: 1.05rem;
        }

        .kpis :global(.small-box p) {
            font-size: 0.66rem;
            line-height: 1.2;
        }

        .kpis :global(.small-box .icon) {
            display: none;
        }

        .kpis :global(.small-box::before) {
            left: 0.7rem;
            top: 0.65rem;
        }
    }
</style>
